var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-outline-danger btn-sm",on:{"click":function($event){$event.preventDefault();return _vm.removeFollower()}}},[_vm._v(_vm._s(_vm.__('group.form.buttons.remove')))])])}
var staticRenderFns = []

export { render, staticRenderFns }